__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "@guildeducationinc/platform";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.7.14", function() { return __webpack_require__.e(827).then(function() { return function() { return __webpack_require__(1827); }; }); });
			register("@datadog/browser-rum", "4.45.0", function() { return __webpack_require__.e(434).then(function() { return function() { return __webpack_require__(33434); }; }); });
			register("@guildeducationinc/auth-frontend-tools", "15.7.0", function() { return __webpack_require__.e(634).then(function() { return function() { return __webpack_require__(94634); }; }); });
			register("@guildeducationinc/mfe-utils", "2.1.4", function() { return __webpack_require__.e(150).then(function() { return function() { return __webpack_require__(82150); }; }); });
			register("@guildeducationinc/playground-mx", "1.2.1", function() { return __webpack_require__.e(227).then(function() { return function() { return __webpack_require__(29227); }; }); });
			register("@guildeducationinc/recess", "10.33.1", function() { return __webpack_require__.e(580).then(function() { return function() { return __webpack_require__(23580); }; }); });
			register("classnames", "2.5.1", function() { return __webpack_require__.e(355).then(function() { return function() { return __webpack_require__(28355); }; }); });
			register("classnames", "2.5.1", function() { return __webpack_require__.e(606).then(function() { return function() { return __webpack_require__(76606); }; }); });
			register("formik", "2.2.9", function() { return __webpack_require__.e(607).then(function() { return function() { return __webpack_require__(91607); }; }); });
			register("graphql", "16.11.0", function() { return __webpack_require__.e(283).then(function() { return function() { return __webpack_require__(50283); }; }); });
			register("libphonenumber-js", "1.12.25", function() { return __webpack_require__.e(263).then(function() { return function() { return __webpack_require__(55263); }; }); });
			register("lodash", "4.17.21", function() { return __webpack_require__.e(635).then(function() { return function() { return __webpack_require__(76635); }; }); });
			register("react-dom", "18.3.1", function() { return __webpack_require__.e(935).then(function() { return function() { return __webpack_require__(73935); }; }); });
			register("react-router-dom", "6.30.4", function() { return __webpack_require__.e(735).then(function() { return function() { return __webpack_require__(98735); }; }); });
			register("react", "17.0.2", function() { return __webpack_require__.e(784).then(function() { return function() { return __webpack_require__(2784); }; }); });
			register("react", "18.3.1", function() { return __webpack_require__.e(294).then(function() { return function() { return __webpack_require__(67294); }; }); });
			register("yup", "1.3.3", function() { return __webpack_require__.e(601).then(function() { return function() { return __webpack_require__(48601); }; }); });
			initExternal(35988);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};